import { motion } from "framer-motion";

const TECH_IMG =
  "https://images.unsplash.com/photo-1729554608003-5ec8be42da1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxmdXR1cmlzdGljJTIwaHVtYW5vaWQlMjByb2JvdCUyMGJsYWNrJTIwYmFja2dyb3VuZCUyMG5lb258ZW58MHx8fHwxNzg5MTU1NzQ3fDA&ixlib=rb-4.1.0&q=85";

const SPECS = [
  { k: "DERMAL SENSORS", v: "11,000 / m²" },
  { k: "SKIN TEMPERATURE", v: "37.2°C adaptive" },
  { k: "ENDOSKELETON", v: "Ti-Alloy Mk VII" },
  { k: "NEURAL ENGINE", v: "AURA-9 Core" },
  { k: "RESPONSE LATENCY", v: "12 ms" },
  { k: "DATA RETENTION", v: "Zero cloud" },
];

export default function TechSection() {
  return (
    <section
      id="tech"
      data-testid="tech-section"
      className="px-4 sm:px-8 lg:px-16 py-20 lg:py-32 border-t border-white/8"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <motion.div
          className="lg:col-span-5 relative"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="absolute -inset-6 bg-[radial-gradient(circle_at_center,rgba(5,217,232,0.12),transparent_65%)] blur-2xl" />
          <div className="relative clip-frame overflow-hidden border border-white/10">
            <img
              src={TECH_IMG}
              alt="Aetheria tactile dermal engineering"
              loading="lazy"
              className="w-full h-[60vh] object-cover"
            />
            <div className="scanlines" />
            <div className="absolute inset-0 bg-gradient-to-t from-void/85 via-transparent to-transparent" />
          </div>
        </motion.div>

        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <p className="font-mono-tech text-xs uppercase tracking-[0.35em] text-cyber mb-4">
              02 // The Engineering
            </p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight mb-6">
              Anatomy of <span className="text-magma">sensation</span>
            </h2>
            <p className="text-base text-slate-400 leading-relaxed max-w-xl mb-12">
              Every Aetheria frame shares the same nervous system — a dermal
              lattice of pressure, temperature and proximity sensors feeding a
              neural core that responds in twelve milliseconds. It doesn't
              simulate touch. It studies it.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-white/8 border border-white/8">
            {SPECS.map((s, i) => (
              <motion.div
                key={s.k}
                data-testid={`tech-spec-${i}`}
                className="bg-panel p-6 hover:bg-[#14161f] transition-colors duration-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
              >
                <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">
                  {s.k}
                </p>
                <p className="font-display font-bold text-lg text-white">{s.v}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
